export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6834.dc7ad2ad.jpg";